<div class="dialog-form">
    <form (submit)="save($event)" [formGroup]="customerForm">
      <p-fieldset legend="Informações Adicionais">
        <div class="form-group flex-row-between">
          <div class="form-control" style="width: 25%;">
            <label for="registration">RG/Identidade</label>
            <input pInputText formControlName="registration" 
                   placeholder="Número do documento"
                   maxlength="50">
          </div>
  
          <div class="form-control" style="width: 25%;">
            <label for="gender">Sexo</label>
            <p-dropdown [options]="genderOptions" 
                       formControlName="gender"
                       appendTo="body"
                       placeholder="Selecione o sexo">
            </p-dropdown>
          </div>

          <div class="form-control" style="width: 25%;">
            <label for="birthday">Data de Nascimento</label>
            <p-calendar formControlName="birthday"
                       dateFormat="dd/mm/yy"
                       [monthNavigator]="true"
                       [yearNavigator]="true"
                       [yearRange]="'1900:2050'"
                       [showIcon]="true"
                       placeholder="Selecione a data">
            </p-calendar>
          </div>
        </div>
  
        <div class="form-group flex-row-between">
          <div class="form-control" style="width: 25%;">
            <label for="maritalStatus">Estado Civil</label>
            <p-dropdown [options]="maritalStatusOptions" 
                       formControlName="maritalStatus"
                       appendTo="body"
                       placeholder="Selecione o estado civil">
            </p-dropdown>
          </div>

          <div class="form-control" style="width: 25%;">
            <label for="spouse">Cônjuge</label>
            <input pInputText formControlName="spouse" 
                   placeholder="Nome do cônjuge"
                   maxlength="50">
          </div>

          <div class="form-control" style="width: 25%;">
            <label for="profession">Profissão</label>
            <input pInputText formControlName="profession" 
                   placeholder="Digite a profissão"
                   maxlength="50">
          </div>
        </div>
      </p-fieldset>
      <div style="height: 20px; margin-bottom: 0px;"></div>
      <p-fieldset legend="Contatos Adicionais" style="margin-top: 20px;">
        <div class="form-group flex-row-between">

          <div class="form-control" style="width: 25%;">
            <label for="phone2">Celular 2</label>
            <p-inputMask mask="+99 (99) 99999-9999" 
                        formControlName="phone2"
                        placeholder="+00 (00) 00000-0000">
            </p-inputMask>
          </div>

          <div class="form-control" style="width: 25%;">
            <label for="residentialPhone">Telefone Residencial</label>
            <p-inputMask mask="(99) 9999-9999" 
                        formControlName="residentialPhone"
                        placeholder="(00) 0000-0000">
            </p-inputMask>
          </div>

          <div class="form-control" style="width: 25%;">
            <label for="commercialPhone">Telefone Comercial</label>
            <p-inputMask mask="(99) 9999-9999" 
                        formControlName="commercialPhone"
                        placeholder="(00) 0000-0000">
            </p-inputMask>
          </div>
        </div>
      </p-fieldset>
  
      <div class="buttons">
        <p-button class="save-button" label="Salvar" type="submit"></p-button>
       
      </div>
    </form>
  </div>